import { Navigate, Route, Routes } from 'react-router-dom';
import { Landing } from '@/routes/Landing';
import { ObservationShell } from '@/routes/ObservationShell';
import { MetadataStep } from '@/routes/MetadataStep';
import { ItemView } from '@/routes/ItemView';
import { SummaryView } from '@/routes/SummaryView';
import { DashboardShell } from '@/components/layout/DashboardShell';
import { OverviewPage } from '@/routes/dashboard/OverviewPage';
import { SiteComparisonPage } from '@/routes/dashboard/SiteComparisonPage';
import { TrendsPage } from '@/routes/dashboard/TrendsPage';
import { ObservationsTablePage } from '@/routes/dashboard/ObservationsTablePage';
import { SiteProfilePage } from '@/routes/dashboard/SiteProfilePage';
import { AuthProvider, useAuth } from '@/lib/auth/AuthContext';
import { SignInScreen } from '@/components/auth/SignInScreen';

function AppRoutes() {
  const { session } = useAuth();
  if (!session) return <SignInScreen />;
  return (
    <Routes>
      <Route path="/" element={<Landing />} />
      <Route path="/observation/:observationId" element={<ObservationShell />}>
        <Route index element={<Navigate to="metadata" replace />} />
        <Route path="metadata" element={<MetadataStep />} />
        <Route path="items/:itemId" element={<ItemView />} />
        <Route path="summary" element={<SummaryView />} />
      </Route>
      <Route path="/dashboard" element={<DashboardShell />}>
        <Route index element={<OverviewPage />} />
        <Route path="sites" element={<SiteComparisonPage />} />
        <Route path="trends" element={<TrendsPage />} />
        <Route path="profile" element={<SiteProfilePage />} />
        <Route path="observations" element={<ObservationsTablePage />} />
      </Route>
      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  );
}

export default function App() {
  return (
    <AuthProvider>
      <AppRoutes />
    </AuthProvider>
  );
}
